import { render, staticRenderFns } from "./MtMaterialsCateModal.vue?vue&type=template&id=1702da70&"
import script from "./MtMaterialsCateModal.vue?vue&type=script&lang=js&"
export * from "./MtMaterialsCateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports